<div class="login-form">
	<h4 class="login-heading">Check your phone</h4>
	<p class="login-subline">We sent a 6-digit code by SMS. It expires in 5 minutes.</p>

	<div class="otp-sentto" *ngIf="sentOtp">
		<span class="ph">{{channelTileLabel}}</span>
		<div>
			{{sentOtp.sentToLocation}}
			<b>{{agent.firstName}} {{agent.lastName}}{{agent.appRole?.name ? ' · ' + agent.appRole?.name : ''}}</b>
		</div>
		<a class="ch" (click)="reset()">Not you?</a>
	</div>

	<form [formGroup]="form" (ngSubmit)="onSubmit()" class="mb-3">
		<input [value]="agent.username" name="username" type="hidden" class="form-control" id="floatingUsername">
		<input [value]="agent.password" name="password" type="hidden" class="form-control" id="floatingPassword">

		<div class="otp-boxes">
			<nz-input-otp
				#otpRef="nzInputOtp"
				id="input-otp"
				[nzLength]="6"
				formControlName="otp"
				appAutoFocus
				name="otp"
				[nzStatus]="message ? 'error' : ''">
			</nz-input-otp>
		</div>
		<div class="otp-error" *ngIf="message">{{message}}</div>

		<ng-container *ngIf="sentOtp">
			<ng-container *ngIf="sentOtp.sentViaChannel == 'AuthenticatorApp'">
				<div class="otp-alt-channels">
					Use your Authenticator app to get your OTP.
					<ng-container *ngFor="let channel of sentOtp.availableChannels">
						<a *ngIf="channel != 'AuthenticatorApp'" class="link" (click)="reSend(channel)">Send an {{channel}} instead</a>
					</ng-container>
				</div>
			</ng-container>
			<ng-container *ngIf="sentOtp.sentViaChannel != 'AuthenticatorApp'">
				<ng-container *ngFor="let channel of sentOtp.availableChannels">
					<div class="otp-alt-channels" *ngIf="channel != sentOtp.sentViaChannel">
						<a class="link" (click)="reSend(channel)">Send an {{channel}} with your OTP instead</a>
					</div>
				</ng-container>
			</ng-container>
		</ng-container>

		<button class="w-100 btn btn-primary login-submit" type="submit" [disabled]="form.invalid" *ngIf="submitting == false">Verify &amp; sign in</button>
		<button class="w-100 btn btn-primary login-submit" type="submit" [disabled]="true" *ngIf="submitting == true">
			<i nz-icon nzType="loading" nzTheme="outline"></i>
		</button>

		<div class="otp-resend">
			<span>
				Didn't get it?
				<a class="b" *ngIf="resendSecondsRemaining <= 0" (click)="reSend()">Resend</a>
				<span *ngIf="resendSecondsRemaining > 0">Resend in <span class="t">{{resendCountdownLabel}}</span></span>
			</span>
			<a class="b" (click)="reset()">Back</a>
		</div>
	</form>
</div>
